import { Login, GetUserInfo } from '@/api/user.js'
import { setToken, getToken } from '@/libs/util'
import { setAuthorization } from '@/libs/api.request'
import { generatorDynamicRouter } from '@/libs/router-util'
import router from '@/router'
import norouter from '@/router/norouter'
import store from '@/store'
export default {
  state: {
    userName: '',
    userId: 0,
    scopeNode: [],
    nodeId: 0,
    userInfo: {},
    avatarImgPath: '',
    token: getToken(),
    access: [],
    MechantName: '',
    ExpireTime: '',
    hasGetInfo: false,
    unReadCount: 0

  },
  mutations: {
    setUnReadCount(state, count) {
      state.unReadCount = Number(count)
    },
    setAvatar(state, avatarPath) {
      state.avatarImgPath = avatarPath
    },
    setUserId(state, id) {
      state.userId = id
    },
    setUserName(state, name) {
      state.userName = name
    },

    setNodeId(state, id) {
      state.nodeId = id
    },
    setScopeNode(state, scopenode) {
      state.scopeNode = scopenode
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setAccess(state, access) {
      state.access = access
    },
    setToken(state, token) {
      state.token = token
      setToken(token)
    },

    setHasGetInfo(state, status) {
      state.hasGetInfo = status
    }

  },

  actions: {

    // 登录
    handleLogin({ commit }, reqData) {
      return new Promise((resolve, reject) => {
        Login(reqData).then(res => {
          commit('setToken', res.token)
          setAuthorization()
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 退出登录
    handleLogOut({ state, commit }) {
      return new Promise((resolve, reject) => {
        // logout(state.token).then(() => {
        //   commit('setToken', '')
        //   commit('setAccess', [])
        //   resolve()
        // }).catch(err => {
        //   reject(err)
        // })
        // 如果你的退出登录无需请求接口，则可以直接使用下面三行代码而无需使用logout调用接口
        sessionStorage.tagNaveList = []
        commit('setToken', '')
        commit('setAccess', [])
        commit('setUserName', '')
        commit('setUserId', 0)
        commit('setNodeId', 0)
        commit('setScopeNode', [])

        commit('setUserInfo', {})
        commit('setHasGetInfo', false)

        resolve()
      })
    },
    // 获取用户相关信息
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          GetUserInfo().then(res => {
            if (res.StatusCode == 200) {
              commit('setAvatar', '')
              commit('setUserName', res.Data.Name)
              commit('setUserId', res.Data.Id)
              commit('setNodeId', res.Data.NodeId)
              commit('setUserInfo', res.Data)
              commit('setAccess', res.Data.Access)
              commit('setScopeNode', res.Data.ScopeNodeList)
              commit('setHasGetInfo', true)

              // store.commit('updateMenuList', res.Data.Menus)

              // store.commit('updateRouternameList', res.Data.Menus.map(x => x.name))

              router.addRoutes(generatorDynamicRouter(res.Data.Menus))
              router.addRoutes([norouter])
            }
            resolve(res)
          }).catch(err => {
            reject(err)
          })
        } catch (error) {
          reject(error)
        }
      })
    }

  }
}
